/**
 * Couleurs par type de lieu, source unique des cartes et de la liste du simulateur (tokens de la
 * palette des maquettes, `assets/styles/index.css`) : teinte du marqueur sur les cartes,
 * déclinaison pastel (fond et texte) pour le badge de la liste.
 */
/** Tracé d'un scénario (carte du détail, mini-cartes des alternatives). */
export const SCENARIO_ROUTE_COLOR = '#166534'

export const PLACE_COLORS = {
  // `marker` : fond du marqueur, lu en `style`. `pinBorderClass` / `stemClass` : bordure et tige
  // pointillée de l'épingle de la maquette (`LogisticsPlacePin`). `solidClass` / `ringClass` :
  // pastille pleine (site de départ d'un camion), même teinte que `badgeText`, et son liseré.
  // `tone` : pastille carrée et nom du lieu d'une ligne de l'onglet Heures (`LogisticsPlaceTile`),
  // bordée de `ringClass`.
  kitchen: {
    marker: 'var(--color-secondary-orange-500)',
    pinBorderClass: 'border-2 border-secondary-orange-300',
    stemClass: 'text-secondary-orange-300',
    badgeText: 'var(--color-secondary-orange-600)',
    badgeBackground: 'var(--color-secondary-orange-100)',
    solidClass: 'bg-secondary-orange-600',
    ringClass: 'border-secondary-orange-300',
    tone: 'var(--color-secondary-orange-500)',
  },
  hub: {
    marker: 'var(--color-secondary-prune-600)',
    pinBorderClass: 'border-[1.5px] border-secondary-prune-300',
    stemClass: 'text-secondary-prune-300',
    badgeText: 'var(--color-secondary-prune-600)',
    badgeBackground: 'var(--color-secondary-prune-100)',
    solidClass: 'bg-secondary-prune-600',
    ringClass: 'border-secondary-prune-300',
    tone: 'var(--color-secondary-prune-500)',
  },
  store: {
    marker: 'var(--color-primary-600)',
    ringClass: 'border-primary-400',
    tone: 'var(--color-primary-600)',
  },
} as const
